import React, { useEffect } from "react";
import moment from "moment";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { Card, Col, Container, Row, Spinner } from "reactstrap";
import { verifyMyBadges } from "store/actions/VerifyBadgesAction";
import ReuseableTable from "components/Tables/ReuseableTable";

const VerifyMyBadges = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [dataLoader, setDataLoader] = useState(true);
  useEffect(() => {
    dispatch(
      verifyMyBadges(id, () => {
        setDataLoader(false);
      })
    );
  }, []);
  const { myBadges } = useSelector((state) => state.verifyBadges);
  const TABLE_DATA = {
    columns: [
      "Fan Name",
      "Fan Email",
      "Athlete Name",
      "Athlete Email",
      "Purchase Amount",
      "Purchase Date",
    ],
    keyMap: {
      "Fan Name": "fanName",
      "Fan Email": "fanEmail",
      "Athlete Name": "athleteFirstName",
      "Athlete Email": "athleteEmail",
      "Purchase Amount": "dataAmount",
      "Purchase Date": "dataCreatedAtSeconds",
    },
    data: {
      fanName: myBadges.fan.name,
      fanEmail: myBadges.fan.email,
      athleteFirstName:
        myBadges.athlete.first_name + " " + myBadges.athlete.last_name,
      athleteEmail: myBadges.athlete.email,
      dataAmount: myBadges.data.amount,
      dataCreatedAtSeconds: moment
        .unix(myBadges.data.createdAt.seconds)
        .format("D MMM YYYY"),
    },
  };
  return (
    <Container className="pt-4">
      <Row className="mt-4">
        <Col md="12">
          <Card className="p-4">
            <h1 className="text-center">This badge details </h1>
            {dataLoader ? (
              <div className="text-center">
                <Spinner color="primary" />
              </div>
            ) : Object.keys(myBadges).length === 0 ? (
              <p>This Badge not found</p>
            ) : (
              <>
                <ReuseableTable {...TABLE_DATA} />
              </>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default VerifyMyBadges;
